import type { PropTypes } from './TaskBox.types';
import type { ReactElement } from 'react';

import { Card, Flex, Heading, Skeleton, Text } from '@rango-dev/whale';
import React from 'react';

import { TaskButton } from '../TaskButton';

import styles from './TaskBox.module.css';

export function TaskBox(props: PropTypes): ReactElement {
  const { className, logo, image, detailsData, detailsLoading, title, description } = props;

  if (detailsLoading || !detailsData) {
    return (
      <Skeleton
        className={styles.skeleton}
        height={{ initial: '152px', sm: '112px', md: '240px' }}
      />
    );
  }

  return (
    <Card size={{ initial: '2', md: '3' }} variant="surface" className={className}>
      <Flex direction="column" align="start" justify="center" width="100%" height="100%">
        <Flex position="relative" width="100%" align="center" gap="4" className={styles.content}>
          {image && <img src={image} alt={title} className={styles.taskImage} />}
          <Flex
            minWidth="0"
            flexGrow="1"
            flexShrink="0"
            flexBasis="0"
            direction={{ initial: 'row', lg: 'column' }}
            align={{ initial: 'center', lg: 'start' }}
            gap={{ initial: '4', md: '3' }}>
            <Flex minWidth="0" flexGrow="1" flexBasis="0" direction="column" gap="3">
              <Flex align="center" gap="2">
                <img src={logo} alt={title} className={styles.logo} />
                <Heading as="h2" size="6" weight="bold" className={styles.title}>
                  {title}
                </Heading>
              </Flex>
              <Text as="p" size="2" weight="medium" className={styles.description}>
                {description}
              </Text>
            </Flex>
            <TaskButton detailsData={detailsData} />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
